import { createAction, props } from '@ngrx/store';
import { AppointmentEntity } from './appointment.models';
import { UpdateAppointmentDTO } from '@care-portals/api-interfaces';

export const loadAllAppointments = createAction(
  '[Appointments] Load All Appointments'
);

export const loadAllAppointmentsSuccess = createAction(
  '[Appointments] Load All Appointments Success',
  props<{ appointments: AppointmentEntity[] }>()
);

export const loadAllAppointmentsFailure = createAction(
  '[Appointments] Load All Appointments Failure',
  props<{ error: any }>()
);

export const loadAppointment = createAction(
  '[Appointment] Load Appointment',
  props<{ id: string }>()
);

export const loadAppointmentSuccess = createAction(
  '[Appointment] Load Appointment Success',
  props<{ appointment: AppointmentEntity }>()
);

export const loadAppointmentFailure = createAction(
  '[Appointment] Load Appointment Failure',
  props<{ error: any }>()
);

export const updateAppointment = createAction(
  '[Appointment] Update Appointment',
  props<{ id: string; appointment: UpdateAppointmentDTO }>()
);

export const updateAppointmentSuccess = createAction(
  '[Appointment] Update Appointment Success',
  props<{ appointment: AppointmentEntity }>()
);

export const updateAppointmentFailure = createAction(
  '[Appointment] Update Appointment Failure',
  props<{ error: any }>()
);

export const getQueuePosition = createAction(
  '[Appointment] Get Queue Position'
);

export const getQueuePositionSuccess = createAction(
  '[Appointment] Get Queue Position Success',
  props<{ position: number }>()
);

export const getQueuePositionFailure = createAction(
  '[Appointment] Get Queue Position Failure',
  props<{ error: any }>()
);

export const stitchInit = createAction('[Appointment] Stitch Initialize');

export const stitchInitSuccess = createAction(
  '[Appointment] Stitch Initialize Success'
);

export const stitchInitFailure = createAction(
  '[Appointment] Stitch Initialize Failure',
  props<{ error: any }>()
);
